import { computed } from 'vue';
import { useQueryV2 } from '@libs/use';
import { DirectDebitsQuery } from '@libs/api-reference';

import * as API from '../requests';

export default function useGetDirectDebitsQuery() {
  const {
    result,
    execute: getDirectDebits,
    isPending: isLoadingDirectDebits,
    isError: isErrorLoadingDirectDebits,
  } = useQueryV2<DirectDebitsQuery>(API.getDirectDebits, {
    key: ['direct-debits'],
  });

  const directDebits = computed(() => result.value?.data || []);

  return {
    getDirectDebits,
    directDebits,
    isLoadingDirectDebits,
    isErrorLoadingDirectDebits,
  };
}
